/* eslint-disable no-nested-ternary */
import React from "react";
import { Icon, Tooltip, classnames } from "@culturehq/components";
import { formatThousand, t } from "app/utils";

const PositiveChange: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span className={classnames("tile_info", "success")}>
    <Icon icon="arrow-up" /> +{children}
  </span>
);

const NegativeChange: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span className={classnames("tile_info", "danger")}>
    <Icon icon="arrow-down" /> {children}
  </span>
);

type ChangeProps = {
  children?: React.ReactNode;
  change: number;
  tooltipMessage?: string;
  dropdownSelection?: { value: string; label: string };
  rangeType?: string;
};

const Change: React.FC<ChangeProps> = (
  { children, change, tooltipMessage, dropdownSelection, rangeType }) => {
  if (change === 0) {
    return null;
  }

  const Direction = change > 0 ? PositiveChange : NegativeChange;

  const getTooltipMessage = () => {
    if (tooltipMessage) return tooltipMessage;

    switch (rangeType) {
      case "lst-30":
        return t("Change in the last 30 days");
      case "lst-60":
        return t("Change in the last 60 days");
      case "lst-90":
        return t("Change in the last 90 days");
      case "year-to-date":
        return t("Change in the year to date");
      case "lst-year":
        return t("Change in the last year");
      case "custom":
        return t("Change in the selected date range");
      default:
        return t("Change in the selected range");
    }
  };

  return (
    <span className="change">
      <Tooltip tip={getTooltipMessage()}>
        <Direction>
          {children || formatThousand(change)}
        </Direction>
      </Tooltip>
    </span>
  );
};

export default Change;
